import heroBgMain from '../assets/images/hero_bg_main.png';
import halfRound from '../assets/images/half_round.png';
import { BiLogoPlayStore } from "react-icons/bi";
import { FaApple } from 'react-icons/fa';

const Home = () => {
  return (
    <>
      <div className="hero-container home-hero" id="home">
        
        {/* Half Round Background */}
        <div className="home-hero-round-bg">
          <img src={halfRound} alt="" className="home-hero-round-img" />
        </div>

        <div className="container home-hero-container">
          <div className="home_section home-hero-section">
            <div className="hero-copy text-white home-hero-copy">
              
              <div className="hero-pill home-hero-pill">
                Powerful Apps Built For You
              </div>
              
              <h1 className="home-hero-title">
                Empower Your <span className="home-hero-title-accent">Digital</span><br/>
                <span className="home-hero-title-accent">journey</span>&nbsp;With&nbsp;Our&nbsp;Apps
              </h1>
              
              <p className="home-hero-description">
                We create stunning cross-platform mobile apps using modern Flutter technology. Whether you're starting with a fresh concept or scaling an existing product, our team ensures seamless execution, beautiful UI, and powerful performance.
              </p>

              {/* Store Buttons */}
              <div className="home-hero-store-btns">
                <a
                  href="https://play.google.com/store/apps/dev?id=6717661217853138886"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-contact-btn home-store-btn"
                >
                  <BiLogoPlayStore size={20} />
                  Play Store
                </a>
                <a
                  href="https://apps.apple.com/sb/developer/di-labs/id1221305504"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-contact-btn home-store-btn"
                >
                  <FaApple size={20} />
                  App Store
                </a>
              </div>
              
            </div>
          </div>
        </div>

        {/* 3D Swoosh Graphic */}
        <div className="home-hero-graphic">
          <img src={heroBgMain} alt="Hero Graphic" className="home-hero-graphic-img" />
        </div>

      </div>
    </>
  );
}

export default Home;
